import * as React from "react"
import { SvgComponentProps } from "../types/SVGPropType"
const SocialSVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={23}
    height={23}
    fill="none"
    {...props}
  >
    <rect
      width={21.802}
      height={21.802}
      x={0.884}
      y={0.337}
      fill="#fff"
      rx={10.901}
    />
    <path
      fill="#0C1518"
      fillRule="evenodd"
      d="M9.102 8.875c0-1.404 1.22-2.542 2.727-2.542s2.728 1.138 2.728 2.542-1.221 2.543-2.728 2.543c-1.506 0-2.727-1.139-2.727-2.543Zm1.6 0c0 .58.505 1.051 1.127 1.051.623 0 1.128-.47 1.128-1.05 0-.581-.505-1.052-1.128-1.052-.622 0-1.127.47-1.127 1.051Z"
      clipRule="evenodd"
    />
    <path
      fill="#0C1518"
      d="M12.792 13.44c1.092-.207 1.747-.689 1.781-.715a.66.66 0 0 0 .115-.971.779.779 0 0 0-1.043-.107c-.006.005-.704.504-1.853.505-1.148-.001-1.86-.5-1.867-.505a.779.779 0 0 0-1.043.107.66.66 0 0 0 .115.971c.035.027.716.521 1.839.724L9.27 14.973a.659.659 0 0 0 .02.977c.143.13.329.194.514.194.194 0 .388-.071.534-.212l1.453-1.443 1.6 1.453c.29.27.76.27 1.05-.001a.659.659 0 0 0-.002-.978l-1.648-1.522Z"
    />
  </svg>
)
export default SocialSVG
